import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import typeTransactionManually from "./typeTransactionManually";
import Pagination from "../../../partials/content/Pagination";

export default function AllTransactionManually() {
  const [allTransactionManually, setAllTransactionManually] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [askTransactionID, setAskTransactionID] = useState(0);
  const [currentTransactionID, setCurrentTransactionID] = useState(0);

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  useEffect(() => {
    getAllTransactionManually();
  }, [currentPage, askTransactionID]);

  const getAllTransactionManually = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allTransactionManually = await sendRequestGetAllTransactionManually(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allTransactionManually) {
      return;
    }
    setAllTransactionManually(allTransactionManually.transaction_manually);
    setCountPage(allTransactionManually.count_page);
  };

  const sendRequestGetAllTransactionManually = async (searchFilterQuery) => {
    const headersRequest = getHeaderRequest();
    let allTransactionManually;
    try {
      allTransactionManually = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/publisher/finance/transaction-manually/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allTransactionManually.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const showReasonTransaction = () => {
    if (!currentTransactionID) {
      return;
    }
    if (allTransactionManually.length == 0) {
      return;
    }
    const transaction = allTransactionManually.filter(
      (transaction) => transaction.trp_id == currentTransactionID
    );
    if (transaction.length == 0) {
      return;
    }
    return transaction[0].trp_reason;
  };

  const generateAllTransactionManually = () => {
    return (
      <>
        <div className="alert alert-info mt-2">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره </label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setAskTransactionID(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="pb-4 px-2">
          <div className="table-responsive pt-2">
            <table className="table table-hilite tbl-td-white-space">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره تراکنش</td>
                  <td>شماره کاربر انجام دهنده</td>
                  <td>شماره کاربر نمایش دهنده</td>
                  <td>مقدار (تومان) </td>
                  <td>واحد تراکنش</td>
                  <td>نوع تراکنش</td>
                  <td>دلیل ایجاد</td>
                  <td>تاریخ ایجاد</td>
                </tr>
              </thead>
              <tbody>
                {allTransactionManually.map((item, index) => {
                  return (
                    <tr>
                      <td>{helperNumbers.toPersianNum(index + 1)}</td>
                      <td>{helperNumbers.toPersianNum(item.trp_id)}</td>
                      <td>
                        {helperNumbers.toPersianNum(item.trp_owner_user_id)}
                      </td>
                      <td>
                        {helperNumbers.toPersianNum(item.trp_publisher_user_id)}
                      </td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(item.trp_amount)
                        )}
                      </td>
                      <td>
                        {
                          typeTransactionManually.getTypeValueString()[
                            item.trp_type
                          ]
                        }
                      </td>
                      <td>
                        {
                          typeTransactionManually.getTypeOperateString()[
                            item.trp_operate
                          ]
                        }
                      </td>
                      <td>
                        <span
                          className="btn btn-info"
                          onClick={(e) => {
                            setCurrentTransactionID(item.trp_id);
                            handleShowModal();
                          }}
                        >
                          <i className="fa fa-eye"></i>
                        </span>
                      </td>
                      <td>
                        {helperNumbers.toPersianNum(
                          item.trp_created_at.split(" ")[1] +
                            " " +
                            helperTime.convertGregorianToJalali(
                              item.trp_created_at.split(" ")[0]
                            )
                        )}{" "}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {countPage > 1 ? generatePagination() : <></>}
        </div>
      </>
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (askTransactionID) {
      searchFilterQuery = `${searchFilterQuery}&id=${askTransactionID}`;
    }

    return searchFilterQuery;
  };

  return (
    <>
      <Sidebar
        openItem="manage-finance"
        activeItem="all-transaction-manually"
      />

      <div className="content-wrapper">
        <TitleBar title="لیست تراکنش های دستی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div>
                <Link
                  to="/finance/manage/transaction-manually/add"
                  className="btn btn-success"
                >
                  <span className="pl-2">
                    <i className="fa fa-plus"> </i>
                  </span>
                  <span>اضافه کردن تراکنش دستی</span>
                </Link>
              </div>
              {allTransactionManually.length == 0 && askTransactionID == 0 ? (
                <></>
              ) : (
                generateAllTransactionManually()
              )}
            </div>
          </div>
        </section>
      </div>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>دلیل انجام تراکنش</Modal.Title>
        </Modal.Header>
        <Modal.Body>{showReasonTransaction()}</Modal.Body>
        <Modal.Footer>
          <span className="btn btn-danger" onClick={handleCloseModal}>
            خروج
          </span>
        </Modal.Footer>
      </Modal>
    </>
  );
}
